import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { EnvService } from './env.service';
import { CallBackTransformService } from './call-back-transform.service';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {
  public agencyName: string;
  public helperName : string;
  public userTitle : string;

  constructor(
    private envService: EnvService,
    private http: HttpClient,
    private callBackTransformService: CallBackTransformService
  ) { }

  /**
 * Agency list
 * @param Object none
 * @return Object Resultset
 */
  getProfile(): Observable<any> {
    const url = this.envService.apiUrl + 'user-profile';
    return this.http.get<any>(url).pipe(
      map(output => {
        this.agencyName = output?.result?.userProfile?.agencyName;
        this.helperName = output?.result?.userProfile?.firstName + ' ' + output?.result?.userProfile?.lastName;
        this.userTitle = output?.result?.userProfile?.title;
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /**
   * Function to save an agency
   * @param profile : adency data object
   */
  saveProfile(profile): Observable<any> {
    const url = this.envService.apiUrl + 'user-profile';
    const config = { headers: {fileFlag: 'true' } };
    return this.http.post(url, profile, config).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  updateProfile(updatedProfile): Observable<any> {
    const url = this.envService.apiUrl + 'user-profile';
    return this.http.put<any>(url, updatedProfile).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
  logOut(){
    const url = this.envService.apiUrl + 'Logout';
    return this.http.post(url, {}).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
}
